import { ExpertsResultsResponse } from '@interfaces/index';
import { useQuery } from '@tanstack/react-query';
import { getHourBufferCategory } from '@utils/date.util';
import { castResponse } from 'custom.d';
import moment from 'moment-timezone';
import { getAllExperts } from './experts';

export const useGetAllExperts = () =>
  useQuery({
    queryKey: ['experts'],
    queryFn: async () => {
      const response = await getAllExperts(null, null, 0, 999, null);

      if (response?.success) {
        const data = castResponse<ExpertsResultsResponse>(response);
        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const userTimeZoneTime = moment.tz(userTimezone).format('YYYY-MM-DD HH:mm:ss');

        const sortedExperts = (data?.results || [])
          .map((expert) => {
            const zoneName = expert?.expertDetail?.zoneName;
            const expertTimeZoneTime = moment.tz(zoneName).format('YYYY-MM-DD HH:mm:ss');

            const differenceInMinutes = moment(expertTimeZoneTime).diff(
              moment(userTimeZoneTime),
              'minutes',
            );

            return {
              ...expert,
              hourBufferCategory: getHourBufferCategory(differenceInMinutes),
            };
          })
          .sort((a, b) => {
            if (a.hourBufferCategory !== b.hourBufferCategory) {
              return a.hourBufferCategory - b.hourBufferCategory;
            }

            return b.orderId - a.orderId;
          });

        return { results: sortedExperts, total: data?.total };
      }

      return { results: [], total: 0 };
    },
  });
